<template>
    <div
        :class="[
            { 'mt-6': useTopMargin },
            alignEnd ? 'flex justify-end' : 'w-fit',
        ]"
    >
        <ButtonPopoverMenu
            v-if="parameterOptions.length > 0"
            :items="parameterOptions"
        >
            <template #button="{ open }">
                <ExpandingIconButton
                    :modelClass="modelClass"
                    :text="text"
                    :expanded="expanded || open"
                    :invertedColors="invertedColors"
                    :icon="icon"
                    :iconSize="iconSize"
                />
            </template>
        </ButtonPopoverMenu>
        <Link v-else :href="url" :data="data">
            <ExpandingIconButton
                :modelClass="modelClass"
                :text="text"
                :expanded="expanded"
                :invertedColors="invertedColors"
                :icon="icon"
                :iconSize="iconSize"
            />
        </Link>
    </div>
</template>

<script>
import { PhPlus } from '@phosphor-icons/vue'
import ExpandingIconButton from '@/Components/Elements/ExpandingIconButton.vue'
import ButtonPopoverMenu from '@/Components/Utilities/ButtonPopoverMenu.vue'
import { markRaw } from 'vue'
import { Link } from '@inertiajs/vue3'

export default {
    components: {
        ExpandingIconButton,
        ButtonPopoverMenu,
        Link,
    },

    props: {
        modelClass: {
            type: String,
            required: true,
        },
        text: {
            type: String,
            required: true,
        },
        url: {
            type: String,
            required: true,
        },
        data: {
            type: Object,
            default: {},
        },
        dataOptions: {
            type: Array,
            default: [],
        },
        useTopMargin: {
            type: Boolean,
            default: false,
        },
        expanded: {
            type: Boolean,
            default: false,
        },
        invertedColors: {
            type: Boolean,
            default: false,
        },
        iconSize: {
            type: String,
            default: 'size-10',
        },
        alignEnd: {
            type: Boolean,
            default: true,
        },
    },

    data() {
        return {
            textWidth: 0,
            isHovered: false,
            icon: markRaw(PhPlus),
        }
    },

    computed: {
        /**
         * Uses the provided dataOptions to generate the parameterOptions for the ButtonPopoverMenu
         * If these are present we generate a popover meny with links instead of a single link
         * This is when there are multiple ways to create a model, maybe different types
         */
        parameterOptions() {
            return this.dataOptions.map((item) => ({
                text: item.text,
                href: this.url,
                // Merge the data from the button with the data from the dataOptions
                data: { ...this.data, ...item.data },
                type: 'link',
            }))
        },
    },
}
</script>
